import { render, staticRenderFns } from "./provision-footer.vue?vue&type=template&id=571d2a34&scoped=true&"
import script from "./provision-footer.vue?vue&type=script&lang=js&"
export * from "./provision-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571d2a34",
  null
  
)

export default component.exports